const routes = [
  {
    path: "/u-pass/student/request",
    name: "u-pass-student-request",
    component: () => import("../pages/student/Request"),
    meta: {
      isAuthenticated: true,
      isStudent: true,
      permission: "upass_studentstatus"
    }
  },
  {
    path: "/u-pass/periods",
    name: "u-pass-periods",
    component: () => import("../pages/admin/Periods"),
    meta: {
      isAuthenticated: true,
      isStaff: true,
      permission: "upassperiod_index"
    }
  },
  {
    path: "/u-pass/purchases",
    name: "u-pass-purchases",
    component: () => import("../pages/admin/Purchases"),
    meta: {
      isAuthenticated: true,
      isStaff: true,
      permission: "upasspurchase_index"
    }
  }
];

export default routes;
